export default {
	CALENDAR: 'CALENDAR',
	LIST: 'LIST',
};
